import { Flex, Form, FormContext, type SelectProps } from 'dash-ui';
import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';
import { useGetUsStatesQuery } from 'gql/generated.graphql';

const StateSelect: FC<SelectProps> = ({ ...selectProps }) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();
  const { data: statesData } = useGetUsStatesQuery();

  const onSelect = (fieldName: FormFields) => (value: string) => {
    stateHandlers[fieldName](value);
    stateHandlers[FormFields.County](null);
    stateHandlers[FormFields.Market](null);
    valid(fieldName, value || '');
    valid(FormFields.Market, formState.market || '');
  };

  return (
    <Flex flexDirection="column" flex={1} mr={2}>
      <Form.Label required>{t('forms:labels.state')}</Form.Label>
      <Form.Select
        value={formState.state}
        options={(statesData?.getUSStates || []).map(({ name }) => ({
          value: name,
          label: name,
        }))}
        placeholder={t('forms:placeholders.selectOne')}
        w="100%"
        onChanged={onSelect(FormFields.State)}
        $errorType={formErrors[FormFields.State]?.type}
        {...selectProps}
      />
      <Form.Feedback $errorType={formErrors[FormFields.State]?.type}>
        {formErrors[FormFields.State]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default StateSelect;
